import { SOCIAL_CTA_LINKS, TWITTER_IMAGE_URLS } from "../config/consts";
import { Hash } from "viem";
import { getTokenTicker } from "./tokenUtils";
import { TokenList } from "../store/global/getAllTokenLists";

export const getDollarTokenArray = (
  takerTokens: Array<Hash>,
  makerTokens: Array<Hash>,
  tokenList: TokenList | undefined
) => {
  const arrayToUse = takerTokens.length > 1 ? takerTokens : makerTokens;
  return arrayToUse.map(token => "$" + getTokenTicker(token, tokenList));
};

export const amperoctoplus = (s: string): string => {
  s = s.replace(/&/g, "%26");
  s = s.replace(/#/g, "%23");
  s = s.replace(/\+/g, "%2B");
  s = s.replace(/@/g, "%40");
  s = s.replace(/:/g, "%3A");
  return s;
};

export const getShareTweetLink = (
  takerTokens: Array<Hash>,
  makerTokens: Array<Hash>,
  tokenList: TokenList | undefined
): string => {
  let tradeType: string;
  if (takerTokens.length > 1) {
    tradeType = "many-to-one";
  } else {
    if (makerTokens.length > 1) {
      tradeType = "one-to-many";
    } else {
      tradeType = "one-to-one";
    }
  }
  const dollarTokenArray = getDollarTokenArray(takerTokens, makerTokens, tokenList);
  const dollarTokensString =
    takerTokens.length > 1 || makerTokens.length > 1 ? dollarTokenArray.join(" / ") : "";
  const baseTokenSymbol = getTokenTicker(takerTokens[0], tokenList);
  const quoteTokenSymbol = getTokenTicker(makerTokens[0], tokenList);

  let tokensTraded: string;
  if (takerTokens.length > 1) {
    tokensTraded = `${dollarTokensString} -> $${quoteTokenSymbol}`;
  } else {
    if (makerTokens.length > 1) {
      tokensTraded = `$${baseTokenSymbol} -> ${dollarTokensString}`;
    } else {
      tokensTraded = `$${baseTokenSymbol} -> $${quoteTokenSymbol}`;
    }
  }
  const amperTokensTraded = amperoctoplus(tokensTraded);
  const pickRandomImage = Math.floor(Math.random() * TWITTER_IMAGE_URLS.length);
  return (
    SOCIAL_CTA_LINKS.SHARE_TWEET_PREFIX +
    encodeURI(
      `I completed a ${tradeType} trade on @bebop_dex with no slippage! ${amperTokensTraded} 
    ${TWITTER_IMAGE_URLS[pickRandomImage]}
    `
    )
  );
};
